import React from "react";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import { fetchAppCheckout } from "actions/app";
import { useFormikContext } from "formik";
import SectionBezel from "components/SectionBezel";
import MultiSelect from "components/Form/fields/MultiSelect";
import { ensureAppCheckout } from "utils/hooks";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import TaxCodeOption from "components/TaxCodeOption";

const TaxFields = ({ name, actions }) => {
  const {
    values,
    touched,
    setFieldTouched,
    setFieldValue
  } = useFormikContext();
  const taxCodePath = getFieldPath(name, "tax_code");
  const taxCode = get(values, taxCodePath);
  const taxCodeTouched = get(touched, taxCodePath);
  const { checkout } = ensureAppCheckout({
    fetchAppCheckout: actions.fetchAppCheckout
  });

  const taxCodes = checkout && checkout.taxCodes ? checkout.taxCodes : [];
  const taxCodeOption = taxCodes.find(({ code }) => code === taxCode);
  let activeValue;
  if (taxCode && taxCodeOption) {
    activeValue = {
      id: taxCode,
      name: taxCodeOption && `${taxCodeOption.code} - ${taxCodeOption.name}`
    };
  }

  const taxCodeProps = {
    value: activeValue ? [activeValue] : [],
    placeholder: "Select tax code",
    isMulti: false,
    options: taxCodes.map(({ code, name, description }) => ({
      id: code,
      label: name,
      description,
      uid: code
    })),
    onChange: () => ({ value }) => {
      if (!taxCodeTouched) {
        setFieldTouched(taxCodePath, true);
      }

      setTimeout(() => setFieldValue(taxCodePath, value), 0);
    },
    labelTransform: (value) => value,
    components: {
      Option: TaxCodeOption
    }
  };

  return (
    <SectionBezel header="Tax">
      <div className="flex flex-column">
        <label className="f6 fw6 db pb2">Code</label>
        <MultiSelect {...taxCodeProps} />
      </div>
    </SectionBezel>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      fetchAppCheckout
    },
    dispatch
  )
});

export default connect(null, mapDispatchToProps)(TaxFields);
